import { Modal, message, Upload, Button } from "antd";
import React, { useState, useCallback } from "react";

import upload from "../../../../assets/icons/export.svg";
import { controller } from "../../controller";

export default function BreakdownRequestModal({ setShowNewBreakdownModal, showNewBreakdownModal, setNewBreakdownID, patient, selectedPolicyID }) {
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  // const [breakdownIDs, setBreakdownIDs] = useState([]);

  const handleSendRequest = async () => {
    setIsUploading(true);

    const formData = new FormData();
    files && files.length > 0 && files.map((file) => formData.append("files", file.originFileObj));
    // formData.append("patient_id", patient.id);
    formData.append("policy_id", selectedPolicyID);

    try {
      const response = await controller.uploadTreatmentBreakdowns(formData);

      if (response.status < 250) {
        message.success("Request sent successfully!");
        setShowNewBreakdownModal(false);
        setNewBreakdownID(response.json.insurance_breakdown_ids[0]);
        setFiles([]);
      }
    } catch (err) {
      message.error("Something went wrong while uploading files.");
      console.error(err);
    }

    setIsUploading(false);
  };

  const handleUploadFiles = useCallback((e) => {
    const uploadedFiles = e.fileList;

    // Filter out duplicates based on file name and other unique properties
    const uniqueFiles = uploadedFiles.filter(
      (newFile, index, self) => index === self.findIndex((f) => f.name === newFile.name && f.size === newFile.size)
    );

    // Update state with unique files
    setFiles(uniqueFiles);
  }, []);

  return (
    <Modal
      title="Insurance Request"
      open={showNewBreakdownModal}
      onCancel={() => setShowNewBreakdownModal(false)}
      style={{ padding: 10 }}
      width={600}
      footer={null}
    >
      <p style={{ color: "#848696" }}>
        Please upload the files that need to be sent for further review. Once uploaded, the files will be processed and sent to the insurance company
        for evaluation.
      </p>

      <div style={{ marginTop: 30 }}>
        <p>Insurance File</p>

        <Upload.Dragger
          name="file"
          multiple={false}
          fileList={files}
          beforeUpload={() => false}
          onChange={handleUploadFiles}
          disabled={isUploading}
          style={{ backgroundColor: "#ffffff", padding: "30px 10px", marginBottom: 30 }}
        >
          <p className="ant-upload-drag-icon">
            <img src={upload} alt="upload" />
          </p>
          <p className="ant-upload-hint">
            Darg and drop or <span style={{ color: "#6b43b5", fontSize: 18 }}>Browse</span> your files
          </p>
        </Upload.Dragger>
      </div>

      <Button
        loading={isUploading}
        type="primary"
        style={{ width: "100%", padding: "20px", fontSize: 18 }}
        onClick={handleSendRequest}
        disabled={files.length === 0}
      >
        Request
      </Button>
    </Modal>
  );
}
